'use client';

import { useIntl } from 'react-intl';
import { BadgeDV } from '../../../../BadgeDV/BadgeDV';

export const TipBadge = () => {
  const { formatMessage } = useIntl();

  return (
    <BadgeDV>
      <span className="text-nowrap">
        {formatMessage({
          id: 'ic.promotion.tip.badge',
          defaultMessage: 'TIPP',
        })}
      </span>
    </BadgeDV>
  );
};
